import IssueItem from "@/components/IssueItem";
import useIsAuthenticated from "@/hooks/useIsAuthenticated";
import { useFetchIssueQuery, usePublicationIssuesQuery } from "@/stores/api";
import { Issue } from "@/stores/types";
import { generateToken } from "@/utils/reader";
import { Box, Button, CircularProgress, Container, Grid } from "@mui/material";

import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

interface Props {}

export default function Publication(props: Props) {
  const { issueId } = useParams();

  const isAuth = useIsAuthenticated();
  const navigation = useNavigate();

  const { data: issue, isLoading } = useFetchIssueQuery(issueId!);
  const { data: history } = usePublicationIssuesQuery(
    {
      publicationId: issue?.publicationId!,
      limit: 3,
    },
    {
      skip: issue?.publicationId === undefined,
    }
  );
  const Loading = useMemo(() => {
    if (isLoading) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      );
    }
    return null;
  }, [isLoading]);

  const onPressIssue = (issue: Issue) => () => {
    if (isAuth) {
      const jwt = generateToken(issue);
      window.location.href = `${process.env.REACT_APP_READER_URL}${jwt}`;
    } else {
      navigation("/authentication/signin", { replace: true });
    }
  };

  return (
    <Container maxWidth={"lg"} sx={{ flex: 1 }}>
      {Loading}
      <Box>
        <Grid
          container
          columnSpacing={4}
          rowSpacing={3}
          direction="row"
          justifyContent="flex-start"
          alignItems="stretch"
        >
          <Grid item xs={12} sm={6} md={3}>
            {issue ? (
              <IssueItem
                image={issue?.coverUrl!}
                onClick={onPressIssue(issue)}
                sx={{
                  maxWidth: 400,
                }}
              />
            ) : null}
          </Grid>
          <Grid item xs={12} sm={6} md={9}>
            <Typography variant={"h4"} sx={{ fontWeight: "800" }}>
              {issue?.publicationName}
              {issue?.number ? `. N# ${issue?.number}` : ""}
            </Typography>
            <Typography variant={"h5"}>
              {issue?.dateParution
                ? dayjs(issue?.dateParution).format("ll")
                : "\u00A0"}
            </Typography>

            {issue ? (
              <Button
                variant="contained"
                sx={{ px: 9, mt: 4, borderRadius: 50 }}
                size="large"
                onClick={issue ? onPressIssue(issue) : undefined}
                type="submit"
              >
                {isAuth ? "Lire" : "Connexion"}
              </Button>
            ) : null}
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ mt: 3 }}>
        {history ? (
          <>
            <Typography variant={"h4"} sx={{ my: 2 }}>
              Anciens numéros
            </Typography>
            <Grid
              container
              columnSpacing={2}
              rowSpacing={3}
              direction="row"
              justifyContent="flex-start"
              alignItems="stretch"
            >
              {history?.items?.map((issue, i) => {
                return (
                  <Grid key={issue.id} item xs={6} sm={3} md={4}>
                    <IssueItem
                      title={issue.publicationName}
                      image={issue?.coverUrl!}
                      publishedAt={issue?.dateParution}
                      // onClick={onPressIssue(publicationNumber)}
                      onClick={() => {
                        navigation(`/publication/${issue.id}`, {
                          replace: true,
                        });
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </>
        ) : null}
      </Box>
    </Container>
  );
}
